import {
    formatCents,
    formatCivilDate,
    getAmountCents,
    getFinancialDate,
    parseBrazilianMoneyToCents,
} from '../domain/finance';

export const normalizeString = (str) => {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};

export function formatarValorMonetario(valor) {
    const cents = typeof valor === 'number' && Number.isFinite(valor)
        ? Math.round(valor * 100)
        : getAmountCents({ valor });
    return Number.isSafeInteger(cents)
        ? formatCents(cents)
        : 'Valor inválido';
}


export function parseFloatFromMonetario(valor) {
    const cents = parseBrazilianMoneyToCents(valor);
    return cents === null ? Number.NaN : cents / 100;
}

// Função para converter o nome do mês em número
export function monthNameToNumber(monthName) {
    const monthsOfYear = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
    const monthNumber = monthsOfYear.findIndex((month) => month === monthName) + 1; // Obtém o número do mês correspondente
    return monthNumber.toString().padStart(2, '0'); // Retorna o número do mês com zero à esquerda, se necessário
}

// Função para obter o nome do mês a partir do número
export function monthNumberToName(monthNum) {
    const monthsOfYear = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
    return monthsOfYear[monthNum - 1];
}


export const getYear = () => {
    return new Date().getFullYear();
}

export function dateToString(timestamp) {
    const financialDate = getFinancialDate({ data: timestamp });
    return formatCivilDate(financialDate);
}


export function getFirstAndLastName(fullName) {
    const nameParts = fullName.trim().split(' ');
    if (nameParts.length === 1) {
        return { firstName: fullName, lastName: '' };
    }
    const firstName = nameParts[0];
    const lastName = nameParts.slice(1).join(' ');
    return { firstName, lastName };
}


// src/utils/index.jsx

export const maskValue = (value, showValues=false, symbol = '$', maskChar = '•', fixedLength = 6) => {
    if (!showValues) {
        const maskedValue = maskChar.repeat(fixedLength);
        return symbol + ' ' + maskedValue;
    }
    return value;
};


// Função utilitária para adicionar alpha a uma cor hex
export const addAlphaToColor = (color, alpha) => {
    const hexToRgb = (hex) => {
      const bigint = parseInt(hex.replace('#', ''), 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;
      return { r, g, b };
    };
  
    const rgbColor = hexToRgb(color);
    return `rgba(${rgbColor.r}, ${rgbColor.g}, ${rgbColor.b}, ${alpha})`;
  };
  